import { render, staticRenderFns } from "./tagDetailsRecord.vue?vue&type=template&id=2110b449&scoped=true&"
import script from "./tagDetailsRecord.vue?vue&type=script&lang=js&"
export * from "./tagDetailsRecord.vue?vue&type=script&lang=js&"
import style0 from "./tagDetailsRecord.vue?vue&type=style&index=0&id=2110b449&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110b449",
  null
  
)

component.options.__file = "tagDetailsRecord.vue"
export default component.exports